import { useCallback, useContext } from 'react';
import AuthContext from '../context/authContext';
import useHttp from './useHttp';

const useMailFactory = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const getMailTypes = useCallback(
    async ({ targetType, targetId }) => {
      const params = { targetType };
      if (targetId) {
        params.targetId = targetId;
      }

      const response = await sendRequest({
        url: '/api/v1/dev-tools/customer-mail-factory/mail-types',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params,
      });

      return response?.mailTypes ?? [];
    },
    [authCtx, sendRequest]
  );

  const searchTargets = useCallback(
    async ({ targetType, searchTerm }) => {
      const params = { targetType };
      if (typeof searchTerm === 'string' && searchTerm.trim().length > 0) {
        params.searchTerm = searchTerm;
      }

      const response = await sendRequest({
        url: '/api/v1/dev-tools/customer-mail-factory/search',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params,
      });

      return response?.results ?? [];
    },
    [authCtx, sendRequest]
  );

  const sendMail = useCallback(
    async ({ targetType, targetId, mailKey }) => {
      return await sendRequest({
        url: '/api/v1/dev-tools/customer-mail-factory/send',
        method: 'POST',
        headers: {
          ...authCtx.getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: {
          targetType,
          targetId,
          mailKey,
        },
      });
    },
    [authCtx, sendRequest]
  );

  return { getMailTypes, searchTargets, sendMail };
};

export default useMailFactory;
